import Helper from "./Helper";

class ChartHideText {
  constructor(config = {}) {
    const {
      chartID
    } = config;
    this.chartID = chartID;
    this.paragraph = document.querySelector('.ns-chart-content p');

    if (this.paragraph) {

      window.addEventListener('chart-change', () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const chartParam = urlParams.get('chart');

        if (this.chartID.includes(chartParam)) {
          this.paragraph.style.display = 'none';
        } else {
          this.paragraph.style.display = 'block';
        }
      });

      this.hideUnhideText();
    }
  }

  hideUnhideText() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const chartParam = urlParams.get('chart');

    if (this.chartID.includes(chartParam)) {
      this.paragraph.style.display = 'none';
    } else {
      this.paragraph.style.display = 'block';
    }
  }
}

export default ChartHideText;
